// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accordion Flush */
.accordion-flush .accordion-item {
    border: 1px solid #e7e7e7;
    border-radius: 0.25rem;
  }
  
  .accordion-flush .accordion-header {
    padding: 0.5rem 1rem;
    margin: 0; /* Adjust based on your design */
    background-color: #f7f7f7;
    border-bottom: 1px solid #e7e7e7;
    cursor: pointer;
  }
  
  .accordion-flush .accordion-button {
    width: 100%;
    text-align: left;
    background-color: #f7f7f7;
    color: #333;
    border: none;
    outline: none;
    transition: background-color 0.3s ease;
    cursor: pointer;
  }
  
  .accordion-flush .accordion-button:not(.collapsed) {
    color: #007bff;
  }
  
  .accordion-flush .accordion-button::after {
    display: inline-block;
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transform: rotate(0);
    transition: transform 0.2s ease-in-out;
  }
  
  .accordion-flush .accordion-button.collapsed::after {
    transform: rotate(-90deg);
  }
  
  .accordion-flush .accordion-collapse {
    margin: 0;
  }
  
  .accordion-flush .accordion-body {
    padding: 1rem;
    background-color: #fff;
    color: #212529;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/TryIt/Accordion.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,SAAS,EAAE,gCAAgC;IAC3C,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,yDAA6R;IAC7R,oBAAoB;IACpB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB","sourcesContent":["/* Accordion Flush */\n.accordion-flush .accordion-item {\n    border: 1px solid #e7e7e7;\n    border-radius: 0.25rem;\n  }\n  \n  .accordion-flush .accordion-header {\n    padding: 0.5rem 1rem;\n    margin: 0; /* Adjust based on your design */\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #e7e7e7;\n    cursor: pointer;\n  }\n  \n  .accordion-flush .accordion-button {\n    width: 100%;\n    text-align: left;\n    background-color: #f7f7f7;\n    color: #333;\n    border: none;\n    outline: none;\n    transition: background-color 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .accordion-flush .accordion-button:not(.collapsed) {\n    color: #007bff;\n  }\n  \n  .accordion-flush .accordion-button::after {\n    display: inline-block;\n    content: \"\";\n    background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/></svg>');\n    transform: rotate(0);\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .accordion-flush .accordion-button.collapsed::after {\n    transform: rotate(-90deg);\n  }\n  \n  .accordion-flush .accordion-collapse {\n    margin: 0;\n  }\n  \n  .accordion-flush .accordion-body {\n    padding: 1rem;\n    background-color: #fff;\n    color: #212529;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
